// client/src/modules/marketing/index.ts
import type { ModuleManifest } from '../types';
import { navItems } from './nav';
import { routes } from './routes';

/**
 * Marketing module manifest (P15)
 *
 * Digital marketing command center: 5-page nav (Dashboard, Content, PR, SEO,
 * Settings). AI-powered drafting, human-in-the-loop approval workflows,
 * multi-channel publishing, SEO/GEO monitoring, and media relations.
 */
export const marketingModule: ModuleManifest = {
  id: 'P15',
  name: 'Marketing',
  shortName: 'Marketing',
  description: 'Digital marketing command center — content calendar, AI drafting, approval workflows, and multi-channel publishing',
  icon: '📣',
  status: 'live',
  urlPrefix: '/marketing',
  routes,
  navItems,
  collections: {
    MARKETING_POSTS: 'marketingPosts',
    MARKETING_ASSETS: 'marketingAssets',
    MARKETING_CAMPAIGNS: 'marketingCampaigns',
    MARKETING_SETTINGS: 'marketingSettings',
    // Marketing analytics — GA4
    GA4_METRICS: 'ga4Metrics',
    // SEO / GEO
    SEO_KEYWORDS: 'seoKeywords',
    SEO_METRICS: 'seoMetrics',
    COMPETITORS: 'competitors',
    COMPETITOR_PAGES: 'pages',
    CITATIONS: 'citations',
    SEO_CANONICAL_NAP: 'seoCanonicalNAP',
    GEO_VISIBILITY: 'geoVisibility',
    GEO_PROMPTS: 'geoPrompts',
    ENTITY_MENTIONS: 'entityMentions',
    GBP_PROFILE: 'gbpProfile',
    GBP_REVIEWS: 'gbpReviews',
    GBP_INSIGHTS: 'gbpInsights',
  },
};

export default marketingModule;
